import React from 'react';

import { Button, Tooltip, Typography } from 'antd';

import type IProduct from 'interfaces/IProduct';
import type { ICheckoutsUrls } from 'scenes/Producer/MyCampaigns';
import { CHECKOUT_ELEMENTS_URL, CHECKOUT_SUN_URL } from 'settings';
import PermissionHide from 'v2/components/Shared/PermissionHide';

import { Icon } from '@eduzz/ui-antd-theme';

interface IProps {
  currentProduct: IProduct;
  openUrlCreatorCheckout: (urls: ICheckoutsUrls) => void;
  openTrackerForm: () => void;
}

const AdvancedConfigsUrls = ({ currentProduct, openUrlCreatorCheckout, openTrackerForm }: IProps) => {
  const productId = currentProduct.hash ?? currentProduct.id;

  return (
    <div className='flex flex-col gap-2'>
      <Typography.Title level={5} className='!mb-0'>
        Configurações Avançadas
      </Typography.Title>
      <div className='flex flex-wrap gap-2 max-sm:flex-col'>
        <PermissionHide action='myeduzz:links:editar'>
          <Button
            onClick={() => {
              openUrlCreatorCheckout({
                linkSun: currentProduct.show_only_checkout_sun_v4 ? undefined : `${CHECKOUT_SUN_URL}/${productId}`,
                linkChk: `${CHECKOUT_ELEMENTS_URL}/${productId}`
              });
            }}
            icon={<Icon.Link size={16} />}
          >
            Gerador de UTM
          </Button>
        </PermissionHide>

        <PermissionHide action='myeduzz:links:editar'>
          {currentProduct.can_create_pixel && (
            <Tooltip
              title='O pixel deve ser cadastrado no produto principal'
              open={!!currentProduct.parent_product ? undefined : false}
            >
              <Button
                disabled={!!currentProduct.parent_product}
                id='trackCampaignButton'
                onClick={openTrackerForm}
                icon={<Icon.Code size={16} />}
              >
                Pixel de Conversão
              </Button>
            </Tooltip>
          )}
        </PermissionHide>
      </div>
    </div>
  );
};

export default AdvancedConfigsUrls;
